// src/ScrollRestoration.jsx
import { useLayoutEffect, useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollRestoration() {
  const location = useLocation();
  const navType = useNavigationType(); // "PUSH" | "POP" | "REPLACE"
  const positions = useRef({});
  const isFirstLoad = useRef(true);

  // Save scroll position before leaving the route
  useLayoutEffect(() => {
    return () => {
      positions.current[location.key] = window.scrollY;
    };
  }, [location]);

  useEffect(() => {
    // On initial mount (or after a hard refresh)
    if (isFirstLoad.current) {
      window.scrollTo(0, 0);
      isFirstLoad.current = false;
      return;
    }

    // Back/forward button → restore
    if (navType === "POP") {
      const y = positions.current[location.key] ?? 0;
      window.scrollTo({ top: y });
    }
    // All other navigation → scroll to top
    else {
      window.scrollTo(0, 0);
    }
  }, [location, navType]);

  return null;
}
